import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics 4 (GA4) integration.
 * Loads gtag.js asynchronously and tracks page views on route changes.
 * 
 * Usage: <Analytics /> inside BrowserRouter
 * Config: Set REACT_APP_GA_ID in frontend .env
 */
const GA_ID = process.env.REACT_APP_GA_ID;

export const Analytics = () => {
  const location = useLocation();

  // Load gtag.js script once
  useEffect(() => {
    if (!GA_ID) return;

    // Avoid double-loading
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_ID}"]`)) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, {
      send_page_view: false, // We handle page views manually on route change
    });
    // GA_ID is a module-level constant that never changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (!GA_ID || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
    // location is the only runtime dependency; GA_ID and window.gtag are stable
  }, [location]);

  return null; // No UI
};
